<template>
  <div>
    <div class="page page__list" v-if="!isChange">
      <search-bar
        @search="onSearch"
        name="os_code,os_vendname,os_buyername"
        placeholder="输入单号、供应商、采购员进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/money/othpayables/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.os_vendname}}</p>
            <p class="list-item-muted">{{item.os_code}}</p>
          </div>
          <div class="weui-cell__ft">
            <p v-format="'¥#,##0.00'">{{item.os_amount}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.os_status!='已审核'}"
            >{{item.os_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
        <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('os_amount')}}</em>
      </div>
    </div>
    <div class="page page__list" v-if="isChange">
      <search-bar
        @search="onSearch"
        name="aa_code,ve_name,araccountapply.creatorName"
        placeholder="输入单号、供应商、申请人进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/money/apaccountapply/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.ve_name}}</p>
            <p class="list-item-muted">{{item.aa_code}}</p>
          </div>
          <div class="weui-cell__ft">
            <p v-format="'¥#,##0.00'">{{item.aa_amount}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.aa_status!='已审核'}"
            >{{item.aa_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
        <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('aa_amount')}}</em>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      isChange: false,
      listUrl: "/api/money/othpayables/list",
      filters: [
        {
          type: "date",
          name: "os_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "os_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "os_statuscode='AUDITED'"
            },
            {
              value: 3,
              label: "待调账"
            }
          ]
        }
      ]
    };
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      let isChange = filter.value == 3
      this.listUrl = isChange ? '/api/money/apaccountapply/list' : '/api/money/othpayables/list'
      this.filters[0].name = isChange ? 'aa_date' : 'os_date'
      this.isChange = isChange
      filterBar.initConfig()
      next()
    },
  }
};
</script>